import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSparkle = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "var(--main-color)",
	viewBox: "0 0 16 14",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m6.4 12.4444-2-4.27773-4.4-1.94445 4.4-1.94444 2-4.27778 2 4.27778 4.4 1.94444-4.4 1.94445zm6.4 1.5556-1-2.1389-2.2-.9722 2.2-.97223 1-2.13889 1 2.13889 2.2.97223-2.2.9722z" })
});
export { SvgSparkle as ReactComponent };
